<!--
  File name: SecurityIncidentForm.vue
  Program Description:
    - This component renders the SecurityIncidentForm from components module that
      contains all the fileds needed for Annual Security Incident Report

  Includes:
    - SecurityIncidentForm
-->
<template>
  <v-container flex>
    <SecurityIncidentForm
      ref="securityIncidentForm"
      :key="operation"
      v-bind="{ name: 'asir', mdTables }"
    />
  </v-container>
</template>

<script>
import mdTables from '@/meta/mdTable/crudModules/'

export default {
  name: 'AsirForm',
  computed: {
    operation () {
      return this.$route.params.operation
    },
    mdTables () {
      return mdTables
    }
  },
  created () {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    confirmLeave () {
      return window.confirm('Are you sure you want to leave? All unsaved data will be lost.')
    },
    confirmStayInDirtyForm () {
      if (!this.$refs.securityIncidentForm.readOnly) {
        return !this.confirmLeave()
      }
    },
    beforeWindowUnload (e) {
      if (!this.$refs.securityIncidentForm.readOnly) {
        if (this.confirmStayInDirtyForm()) {
          e.preventDefault()
          // Chrome requires returnValue to be set
          e.returnValue = ''
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$s.session.userRole.includes('guest') && this.confirmStayInDirtyForm()) {
      next(false)
    } else {
      next()
    }
  }
}
</script>
